import { render, staticRenderFns } from "./AccountSectionTitle.vue?vue&type=template&id=93ae802a&scoped=true&"
var script = {}
import style0 from "./AccountSectionTitle.vue?vue&type=style&index=0&id=93ae802a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ae802a",
  null
  
)

export default component.exports